import { FC } from 'react';

import { Flex } from '@servicetitan/anvil2';
import { TableDetailRowProps } from '@servicetitan/table';

import { OutboundMessage } from '../api/telecom.api';
import { formatTelecomDate } from '../utils/date-format';
import { getPriorityDisplayName } from '../utils/enum-display.utils';
import { LabelText, FieldText } from '../components/text-components';

import * as Styles from './outbound-messages.module.less';

export const DetailsRow: FC<TableDetailRowProps> = ({ dataItem }) => {
    const message = dataItem as OutboundMessage;

    return (
        <div className={Styles.detailsRow}>
            <Flex direction="row" gap="4">
                <Flex direction="column" gap="2">
                    <LabelText>SID</LabelText>
                    <LabelText>Sender</LabelText>
                    <LabelText>Date Sent</LabelText>
                    <LabelText>Priority</LabelText>
                    <LabelText>Media Urls</LabelText>
                    <LabelText>Error Message</LabelText>
                    <LabelText>Text</LabelText>
                </Flex>
                <Flex direction="column" gap="2">
                    <FieldText>{message.messageSid || '-'}</FieldText>
                    <FieldText>{message.senderNumberE164 || '-'}</FieldText>
                    <FieldText>{formatTelecomDate(message.dateSent)}</FieldText>
                    <FieldText>{getPriorityDisplayName(message.priority)}</FieldText>
                    <FieldText>
                        {message.mediaUrls?.length ? message.mediaUrls.join(', ') : 'Null'}
                    </FieldText>
                    <FieldText>{message.errorMessage || '-'}</FieldText>
                    <FieldText>{message.text || '-'}</FieldText>
                </Flex>
            </Flex>
        </div>
    );
};
